import { Directive, TemplateRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[wrDetailView]'
})
export class DetailViewDirective {

  constructor(
    public readonly templateRef: TemplateRef<any>,
  ) {
  }
}
